module.exports = __webpack_public_path__ + "media/zinc_gallery_2.1b43ebf1.mp4";